module.exports = __webpack_public_path__ + "static/img/The Star.a276f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Star.jpg
// module id = 1321
// module chunks = 0